import React, { useState, useEffect } from "react";
import CountryCodePicker from "../components/booking/common/CountryCodePicker";
import { useNavigate, useLocation } from "react-router-dom";
import { AppContext } from "../components/services/AppContext";
import { sendOtp } from "../components/services/userService";
import "../styles/commonStyle.css";
import logo from '../assets/logo.png';

const LoginPage: React.FC = () => {
  const navigate = useNavigate();

  const location = useLocation();

  const [phone, setPhone] = useState("");
  const [isLogin, setIsLogin] = useState<boolean>(true);
  const [phoneInputError, setPhoneInputError] = useState('')
  const [isPhoneError, setIsPhoneError] = useState(false)


  useEffect(() => {

    if (location.state?.phone) {
      setPhone(location.state.phone);
      setIsLogin(location.state.isLogin)
    }
  }, [location.state]);

  const onPhoneChange = (phone: string, phoneError: boolean) => {
    setPhone(phone)
    setIsPhoneError(phoneError)
    setPhoneInputError("")
  }

  const handleSendOtp = async () => {
    if (isPhoneError)
      return

    if (!phone || phone.length < 10) {
      setPhoneInputError("Please Enter a valid phone number")
      return;
    }
    setPhoneInputError('')
    console.log("Sending OTP to:", AppContext.phone);

    const result = await sendOtp(AppContext.phone);
    if (!result) return;

    if (isLogin) navigate("/OtpValidationPage", { state: { phone, isLogin } });
    else navigate("/validateAndRegister", { state: { phone, isLogin } });
  };
  const handleIsLogin = (value: boolean) => {
    setIsLogin(value);
    setPhone('')
    AppContext.phone = ''
  };


  return (
    <>
      <div
        className="d-flex justify-content-center align-items-start px-2 pt-5"
        style={{
          minHeight: '100vh',
          fontFamily: `'Inter', 'Segoe UI', sans-serif`,
        }}
      >
        <div className="w-100 bg-white rounded-4 shadow-sm border px-4 py-4" style={{ maxWidth: '420px' }}>
          <div className="text-center mb-3">
            <img src={logo} alt="Logo" height="36" />
          </div>

          <h5 className="text-center fw-bold mb-1 fs-5 textSuccessGreen">
            {isLogin ? 'Log in to Continue' : 'Create your Account'}
          </h5>

          <p className="text-center text-muted mb-4 customTextSm">
            Enter your WhatsApp number to receive an OTP
          </p>

          <div className="mb-3">
            <CountryCodePicker phoneText={phone} onChange={onPhoneChange} />
            {phoneInputError && (
              <div className="text-danger small mt-1">{phoneInputError}</div>
            )}
          </div>

          <button
            type="button"
            onClick={handleSendOtp}
            className="btn w-100 fw-semibold primary-button"
          >
            Send OTP
          </button> 

          <div className="text-center mt-4">
            <span className="text-muted customTextSm" >
              {isLogin ? 'New user?' : 'Already have an account?'}
            </span>
            <button
              type="button"
              className="btn ps-2 text-decoration-none customTextSm fw-medium textSuccessGreen "
              onClick={() => handleIsLogin(!isLogin)}
            >
              {isLogin ? 'Sign Up' : 'Log In'}
            </button>
          </div>
        </div>
      </div>





    </>
  );
};

export default LoginPage;
